<app-nav></app-nav>

<main class="page">

  <section class="head">
    <div>
      <h1>Create Your <span>Digital Card</span></h1>
      <p>Choose a template, customize, and share your card with the world.</p>
    </div>
    <div class="head-quote">One Card.<br />Unlimited<br />Opportunities.</div>
  </section>

  <ol class="stepper">
    <li *ngFor="let s of steps; let i = index" [class.active]="i === 0">
      <span class="num">{{ i + 1 }}</span>
      <small>{{ s }}</small>
    </li>
  </ol>

  <section class="carousel-wrap">
    <ngx-slick-carousel [config]="slickCarouselConfig" class="carousel">
      <div ngxSlickItem *ngFor="let n of templates" class="slide">
        <div class="tpl">
          <div class="img-scroll">
            <img [src]="'assets/images/template/' + n + '.png'" [alt]="'Template ' + n" />
          </div>
          <a [routerLink]="['/create-card-steps', n]" class="select-btn">Select This Template</a>
        </div>
      </div>
    </ngx-slick-carousel>
  </section>

</main>